import { render, staticRenderFns } from "./xuekesubject.vue?vue&type=template&id=348f86a6&scoped=true"
import script from "./xuekesubject.vue?vue&type=script&lang=js"
export * from "./xuekesubject.vue?vue&type=script&lang=js"
import style0 from "./xuekesubject.vue?vue&type=style&index=0&id=348f86a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348f86a6",
  null
  
)

export default component.exports